import React from 'react';
import { View, StyleSheet } from 'react-native';
import { MyEventModel } from '../../types';
import { RegistrationDetail } from './RegistrationDetails';
import { Ticket } from './Ticket';

type Props = {
  event: MyEventModel;
  onClose: Function;
};

export const RegistrationTickets = ({ event, onClose }: Props) => {
  return (
    <>
      {event && (
        <View style={styles.container}>
          <RegistrationDetail event={event} showActions={true} showClose={true} onClose={onClose} />
          <Ticket event={event} />
        </View>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 24,
    paddingHorizontal: 0,
    zIndex: 10,
    margin: 'auto',
    width: 343,
  },
});
